import React, { useState } from 'react';
import InfoField from './InfoField';
import { FiEye } from 'react-icons/fi'; // Import the Eye icon
import PdfPreviewModal from '../../ClientModule/PdfPreviewModal';

const EducationDetailsSection = ({ educationChecks }) => {
  const [showImageModal, setShowImageModal] = useState(false);
  const [currentImage, setCurrentImage] = useState('');
  const [previewUrl, setPreviewUrl] = useState('');

  const openImageModal = (imageUrl) => {
    setCurrentImage(imageUrl);
    setShowImageModal(true);
  };

  const closeImageModal = () => {
    setShowImageModal(false);
    setCurrentImage('');
  };

 const handlePreview = (fileUrl) => {
  if (!fileUrl) return;

  if (isImageUrl(fileUrl)) {
    setCurrentImage(fileUrl);
    setShowImageModal(true);
  } else {
    setPreviewUrl(fileUrl);
  }
};


  const isImageUrl = (url) => {
    if (!url) return false;
    return /\.(jpeg|jpg|png|gif|bmp|webp)$/i.test(url);
  };

  if (!educationChecks || educationChecks.length === 0) {
    return (
      <div className="report-section">
        <h2 className="section-title">Education Details</h2>
        <p>No education details available.</p>
      </div>
    );
  }

  return (
    <div className="admin-report-section">
      <h2 className="admin-section-title">Education Details</h2>
      {educationChecks.map((edu, index) => (
        <div key={index} className="education-entry-card">
          <h3>Education Entry {index + 1}</h3>
          <div className="grid-container">
            <InfoField label="Qualification" value={edu.qualification || 'N/A'} />
            <InfoField label="Specialization" value={edu.specialization || 'N/A'} />
            <InfoField label="Education Level" value={edu.educationLevel || 'N/A'} />
            <InfoField label="Enrolled Year" value={edu.enrolledYear || 'N/A'} />
            <InfoField label="Passing Year" value={edu.passingYear || 'N/A'} />
            <InfoField label="Institute Name" value={edu.instituteName || 'N/A'} />
            <InfoField label="Enrollment Number" value={edu.enrollmentNumber || 'N/A'} />
            <InfoField label="Remarks" value={edu.remarks || 'N/A'} />

{edu.educationProofFileName && (
  <InfoField
    label="Education File"
    value={
      <div className="file-preview-container">
        <button
          className="preview-btn"
          onClick={() => handlePreview(edu.educationProofFileName)}
        >
          <FiEye className="preview-icon" /> View File
        </button>
      </div>
    }
  />
)}
          </div>
        </div>
      ))}

      {showImageModal && (
        <div className="image-modal-overlay" onClick={closeImageModal}>
          <div className="image-modal-content" onClick={(e) => e.stopPropagation()}>
            <span className="image-modal-close" onClick={closeImageModal}>&times;</span>
            <img src={currentImage} alt="Large View" className="large-image" />
          </div>
        </div>
      )}

      {previewUrl && (
      <PdfPreviewModal
        fileUrl={previewUrl}
        onClose={() => setPreviewUrl(null)}
      />
      )}
    </div>
  );
};

export default EducationDetailsSection;